<template>
  <el-container />
</template>

<script>
import { mapActions } from "vuex";
import OperatorService from "@/api/services/operator.service";
import Vue from "vue";

export default {
  name: "AuthByToken",
  props: {
    operator: {
      type: Number,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
    redirectPath: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      loading: this.$loading({
        lock: true,
        text: "Авторизация",
      }),
    };
  },
  created() {
    this.checkProps();

    this.getToken({ token: this.token, id_operator: this.operator })
      .catch((e) => {
        this.$message.error(e.response.data.error || "Неизвестная ошибка");
        this.$router.push("/");
      })
      .then(this.clearTokenCookie)
      .then(this.setOperator)
      .then(this.getProfile)
      .then(this.onAuthSuccess)
      .finally(() => {
        this.loading.close();
      });
  },
  methods: {
    ...mapActions("auth", { getToken: "GET_TOKEN_FROM_ADMIN" }),
    ...mapActions("profile", { getProfile: "GET_PROFILE" }),
    checkProps() {
      const propsArray = Object.keys(this.$props);
      const propsIsSet = propsArray.every((prop) => !this.$props[prop].reqired || this[prop]);

      if (!propsIsSet) {
        this.$message.error("Произошла ошибка во время авторизации. Проверьте правильность ссылки");
        this.$router.push("/");
      }
    },
    clearTokenCookie() {
      Vue.$cookies.remove('vk-operator-token');
    },
    setOperator() {
      return OperatorService.setOperatorId(this.operator);
    },
    onAuthSuccess() {
      this.$message.success(`Авторизация в личном кабинете оператора "${this.operator}"  успешно выполнена`);
      this.loading.close();
        if (this.redirectPath) {
          this.$router.push("/" + this.redirectPath);
        }
        else {
          this.$router.push("/");
        }
    },
  },
};
</script>
